<template>
  <div class="page__info">
      <h3 v-html="$t(`${namespace}.titleForWhat`)" class="mb-1" />
      <p v-html="$t(`${namespace}.textForWhat`)" />
      <p v-html="$t(`${namespace}.textBeforeRequest`)" />
  </div>
</template>
<script>
export default {
  name: 'RequestInfo',
  data () {
    return {
      namespace: 'Views.TokenRequestPage'
    }
  }
}
</script>
<style lang="scss" scoped>
.page__info {
      padding: 24px;

    h3, p {
        font-size: 14px;
    }
}
</style>
